import { render, staticRenderFns } from "./FuelOil.vue?vue&type=template&id=2d5b65db&scoped=true&"
import script from "./FuelOil.vue?vue&type=script&lang=js&"
export * from "./FuelOil.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d5b65db",
  null
  
)

export default component.exports